module.exports = __webpack_public_path__ + "static/top-2414207d19fc9ec3fe320da9f7916f8b.png";